module.exports = __webpack_public_path__ + "static/2-d7eb8d3a7d1e19817c52143ae46cd5b9.png";